import React from "react";
import PropTypes from "prop-types";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Skeleton,
  Stack,
  Typography,
} from "@mui/material";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import { HEADER_COLOR, POPPINS } from "./dashboardTypography";

const ChartCard = ({ title, subtitle, loading, error, isEmpty, onRetry, onExport, children }) => {
  return (
    <Card variant="outlined" sx={{ borderRadius: 2, height: "100%" }}>
      <CardHeader
        title={title}
        titleTypographyProps={{ ...POPPINS, fontSize: 15, fontWeight: 700, color: HEADER_COLOR }}
        subheader={subtitle}
        subheaderTypographyProps={{ ...POPPINS, fontSize: "0.74rem", color: "#64748B" }}
        action={
          onExport ? (
            <Button size="small" startIcon={<DownloadOutlinedIcon fontSize="small" />} onClick={onExport} sx={{ ...POPPINS, fontSize: "0.78rem", textTransform: "none", fontWeight: 600 }}>
              Export
            </Button>
          ) : null
        }
      />
      <CardContent>
        {loading && <Skeleton variant="rounded" height={280} />}
        {!loading && error && (
          <Stack alignItems="center" spacing={1} sx={{ py: 4 }}>
            <ErrorOutlineOutlinedIcon color="error" />
            <Typography variant="body2" color="text.secondary" sx={{ ...POPPINS, fontSize: "0.78rem" }}>
              {error}
            </Typography>
            <Button size="small" onClick={onRetry} sx={{ ...POPPINS, fontSize: "0.76rem", textTransform: "none" }}>Retry</Button>
          </Stack>
        )}
        {!loading && !error && isEmpty && (
          <Box sx={{ py: 8, textAlign: "center" }}>
            <Typography variant="body2" color="text.secondary" sx={{ ...POPPINS, fontSize: "0.78rem" }}>
              No data available for the selected filters.
            </Typography>
          </Box>
        )}
        {!loading && !error && !isEmpty && children}
      </CardContent>
    </Card>
  );
};

ChartCard.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  loading: PropTypes.bool,
  error: PropTypes.string,
  isEmpty: PropTypes.bool,
  onRetry: PropTypes.func,
  onExport: PropTypes.func,
  children: PropTypes.node,
};

ChartCard.defaultProps = {
  subtitle: "",
  loading: false,
  error: "",
  isEmpty: false,
  onRetry: null,
  onExport: null,
  children: null,
};

export default ChartCard;
